module.exports = __webpack_public_path__ + "bced869682e902b3469b14b7a9b8c103.pdf";